export default "__VITE_ASSET__T5IpaopE__"